/**
 * BodySpecAdmin.tsx — Admin → Integrations → BodySpec.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function BodySpecAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="bodyspec"
      title="BodySpec"
      subtitle="In-person / mobile DEXA body-composition scans via the BodySpec API"
      vendorName="BodySpec"
    />
  );
}
